"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.wxpTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.wxpTemplates = [
    {
        id: "office-addin-outlook-taskpane-ts",
        name: templateNames_1.TemplateNames.OutlookTaskpane,
        language: "typescript",
        description: "",
    },
    {
        id: "office-addin-wxpo-taskpane-ts",
        name: templateNames_1.TemplateNames.WXPTaskpane,
        language: "typescript",
        description: "",
    },
    {
        id: "office-addin-config-ts",
        name: templateNames_1.TemplateNames.OfficeAddinCommon,
        language: "typescript",
        description: "",
    },
];
//# sourceMappingURL=wxp.js.map